import Paper from '@mui/material/Paper';
import {styled} from '@mui/material/styles';

const innerTabRootStyles = ({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3),
  paddingTop: theme.spacing(1),
});

export const InnerTabRoot = styled('div')(innerTabRootStyles);
// Top padded for to be used with bare items (No top search items)
export const InnerTabRootPadded = styled('div')(({ theme }) => ({
  ...innerTabRootStyles({theme}),
  paddingTop: theme.spacing(3),
}));


const innerRootStyles = ({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3),
  paddingTop: theme.spacing(1),
});
export const InnerRoot = styled('div')(innerRootStyles);
export const InnerRootPadded = styled('div')(({ theme }) => ({
  ...innerRootStyles({theme}),
  paddingTop: theme.spacing(3),
}));

export const InnerTabPaper = styled(Paper)(innerTabRootStyles);
export const DrawerRoot = styled('div')(({ theme }) => ({
  flexGrow: 1,
  width: 400,
  padding: theme.spacing(2),
}));

export const DrawerRootExtended = styled(DrawerRoot)({
  width: 800,
});

const tableHolderRootStyles = {
  padding: '5px 10px 20px 10px',
};

export const TableHolderRoot = styled('div')(tableHolderRootStyles);

export const TableHolderPaper = styled(Paper)(tableHolderRootStyles);

export const WidgetHeadingContainer = styled('div')({
  paddingLeft: '8px',
  paddingRight: '8px',
  paddingTop: '8px',
});
